import React from "react"
import strings from "../../../localization/strings"
import { Dialog, FlatButton } from "material-ui"
import { IPunchResult, IUIUser, EPunchStage, ITimecardEmployee } from "../../../models"
import GlobalPunchEmployeesInfoHoverIcon from "../global_punch/GlobalPunchEmployeesInfoHoverIcon"
import PunchResultTable from "./PunchResultTable"
interface IProps {
    results: IPunchResult[]
    handleClose(): void

    // global punch
    isGlobalPunch?: boolean
    globalPunchEmployees?: ITimecardEmployee[]
}

const PunchResultDialog: React.SFC<IProps> = (props: IProps) => {
    if (props.results.length === 0) return null
    const validationErrors = props.results.filter(i => i.Stage === EPunchStage.CheckValidate)
    const executionResults = props.results.filter(i => i.Stage === EPunchStage.Execution)
    return (
        <Dialog
            open
            autoScrollBodyContent
            title={props.isGlobalPunch ?
                [
                    <h3 key="title" style={{ display: "inline-block", margin: 0, padding: "24px 24px 20px", colorr: "rgb(97, 97, 97)", fontSize: 22, lineHeight: "32px", fontWeight: 400 }}>{strings.Global_Punch_Results}</h3>,
                    <GlobalPunchEmployeesInfoHoverIcon
                        key="info"
                        style={{ display: "inline-block", marginRight: 20 }}
                        globalPunchEmployees={props.globalPunchEmployees as IUIUser[]}
                    />
                ] :
                strings.Errors
            }
            titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
            actions={[
                <FlatButton
                    label={strings.OK}
                    primary
                    onClick={props.handleClose}
                />
            ]}
        >
            <div>
                {validationErrors.length > 0 &&
                    <PunchResultTable
                        isGlobalPunch={props.isGlobalPunch}
                        stage={EPunchStage.CheckValidate}
                        results={validationErrors}
                    />
                }
                {executionResults.length > 0 &&
                    <div style={{ marginTop: validationErrors.length > 0 ? 20 : 0 }}>
                        <PunchResultTable
                            isGlobalPunch={props.isGlobalPunch}
                            stage={EPunchStage.Execution}
                            results={executionResults}
                        />
                    </div>
                }
            </div>
        </Dialog>
    )
}

export default PunchResultDialog